@if (loading()) {
  <div class="loader">
    <nx-spinner
      class="spinner"
      size="large"
      activationAnnouncement="'Loading data'"
      completionAnnouncement="'Done loading data'"
    ></nx-spinner>
  </div>
}
